/************
 * Developed by : Shiva Software Solutions
 * Date : 25-04-2024
 * Descriptions : Call api response using reducers
 ************/
import {
  SEARCH_DISPENSES_PENDING,
  SEARCH_TOTAL_COUNT,
  ERX_IMG_ARR_LST,
  SEARCH_LIST_RESP,
  SAVE_DISPENSES_MSG,
  SEARCH_DISPENSED_LIST,
  ERX_IMAGES_ARRAY,
  ERX_DISPENSED_IMAGES_ARRAY,
  SEARCH_DISPENSE_LIST_RESP,
  SEARCH_SARVO_LIST_RESP,
  SEARCH_SARVO_DISPENSES_PENDING,
  SEARCH_SARVO_TOTAL_COUNT,
  ERX_DATA_IMAGES_ARRAY,
  ERX_DATA_DISPENSED_IMAGES_ARRAY,
  SEARCH_SARVO_DISPENSED_LIST,
  SEARCH_SARVO_DISPENSE_LIST_RESP,
  SAVE_SARVO_DISPENSES_MSG,
  PHARMACY_CALLBACK_PENDING_LIST,
  PHARMACY_CALLBACK_COMPLETED_LIST,
  PHARMACY_CALLBACK_PENDING_COUNT,
  PHARMACY_CALLBACK_COMPLETED_COUNT,
  PAID_FLAG,
  CALLBACK_REASON,
  SAVE_CALLBACK_MSG,
  BOT_STATUS_DATA,
} from '../../shared/constants/ActionTypes';

const initialState = {
  pendingDispenses: [],
  totalCount:0,
  searchListResp: '',
  saveDispensesMsg: '',
  erximgdatas: [],
  searchDispensedList: [],
  erxImagesArray: [],
  erxImagesDispensedArr: [],
  searchDispenseListResp: '',
  searchSarvoListResp: '',
  pendingSarvoDispenses: [],
  sarvototalCount:0,
  erxDataImagesArray: [],
  erxDataImagesDispensedArr: [],
  searchSarvoDispensedList: [],
  searchSarvoDispenseListResp: '',
  saveSarvoDispensesMsg: '',
  pharmacyCallbackPendingList: [],
  pharmacyCallbackCompletedList: [],
  pharmacyCallbackPendingCount: 0,
  pharmacyCallbackCompletedCount: 0,
  paidFlag: false,
  callbackReason: [],
  saveCallbackMsg: '',
  botStatusData: []
};

const pharmacyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_DISPENSES_PENDING:
      return {
        ...state,
        pendingDispenses: action.payload,
      };
      case SEARCH_TOTAL_COUNT:
        return {
          ...state,
          totalCount: action.payload,
        };
    case ERX_IMAGES_ARRAY:
      return {
        ...state,
        erxImagesArray: action.payload,
      };
    case ERX_DISPENSED_IMAGES_ARRAY:
      return {
        ...state,
        erxImagesDispensedArr: action.payload,
      };
    case ERX_IMG_ARR_LST:
      return {
        ...state,
        erximgdatas: action.payload,
      };
    case SEARCH_DISPENSE_LIST_RESP:
      return {
        ...state,
        searchDispenseListResp: action.payload,
      };
    case SEARCH_LIST_RESP:
      return {
        ...state,
        searchListResp: action.payload,
      };
    case SAVE_DISPENSES_MSG:
      return {
        ...state,
        saveDispensesMsg: action.payload,
      };
    case SEARCH_DISPENSED_LIST:
      return {
        ...state,
        searchDispensedList: action.payload,
      };
    case SEARCH_SARVO_LIST_RESP:
      return {
        ...state,
        searchSarvoListResp: action.payload,
      };
    case SEARCH_SARVO_DISPENSES_PENDING:
      return {
        ...state,
        pendingSarvoDispenses: action.payload,
      };
    case SEARCH_SARVO_TOTAL_COUNT:
        return {
          ...state,
          sarvototalCount: action.payload,
        };
    case ERX_DATA_IMAGES_ARRAY:
      return {
        ...state,
        erxDataImagesArray: action.payload,
      };
    case ERX_DATA_DISPENSED_IMAGES_ARRAY:
      return {
        ...state,
        erxDataImagesDispensedArr: action.payload,
      };
    case SEARCH_SARVO_DISPENSED_LIST:
      return {
        ...state,
        searchSarvoDispensedList: action.payload,
      };
    case SEARCH_SARVO_DISPENSE_LIST_RESP:
      return {
        ...state,
        searchSarvoDispenseListResp: action.payload,
      };
    case SAVE_SARVO_DISPENSES_MSG:
      return {
        ...state,
        saveSarvoDispensesMsg: action.payload,
      };
    case PHARMACY_CALLBACK_PENDING_LIST:
      return {
        ...state,
        pharmacyCallbackPendingList: action.payload,
      };
    case PHARMACY_CALLBACK_COMPLETED_LIST:
      return {
        ...state,
        pharmacyCallbackCompletedList: action.payload,
      };
    case PHARMACY_CALLBACK_PENDING_COUNT:
      return {
        ...state,
        pharmacyCallbackPendingCount: action.payload,
      };
    case PHARMACY_CALLBACK_COMPLETED_COUNT:
      return {
        ...state,
        pharmacyCallbackCompletedCount: action.payload,
      };    
    case PAID_FLAG:
      return {
        ...state,
        paidFlag: action.payload,
      };    
    case CALLBACK_REASON:
      return {
        ...state,
        callbackReason: action.payload,
      };    
    case SAVE_CALLBACK_MSG:
      return {
        ...state,
        saveCallbackMsg: action.payload,
      };    
    case BOT_STATUS_DATA:
      return {
        ...state,
        botStatusData: action.payload,
      };
    default:
      return state;
  }
};
export default pharmacyReducer;
